import React, { useMemo, Fragment } from 'react';
import { formatDate } from '../../../../utils/helpers';
import { FlexDiv } from '../../../design-system/containers';
import { TextLabel } from '../../../design-system/texts';

const DetailsField = ({ children }) => {
    return <tr style={{ fontSize: '11px' }}>{children}</tr>;
};

export default DetailsField;
